import {displayLanguageListItems, russianLanguageId} from '../../../../util/uiconstants';

export default (isLowerEnv) =>
	displayLanguageListItems
		.filter(({id}) => isLowerEnv || id !== russianLanguageId)
		.map(({languageISOCode, label, id}) => ({id, value: String(languageISOCode), label}));
